import React, { PropsWithChildren } from 'react';
import Bem from '../../../../lib/bemUtils/bem';

export function AnnouncementCategory({ children }: Readonly<PropsWithChildren>) {
  return (
    <header className={Bem('announcement__category')}>{children}</header>
  );
}
